import { useLoaderData } from 'react-router';

import { useInvoice } from '~/api/invoices';
import { Redirect } from '~/components';
import { r, routes } from '~/providers/RouterProvider/router.routes';

import type { loader } from './EditInvoice.loader';

import { CreateEditInvoiceForm } from './CreateEditInvoiceForm';

export const EditInvoice = () => {
  const loaderData = useLoaderData<typeof loader>();
  const { data: invoice } = useInvoice(loaderData.id);

  if (!invoice) return <Redirect to={routes.invoices} />;

  if (invoice.status !== 'LockedByUser') return <Redirect to={r(routes.showInvoice, { invoiceId: invoice.id })} />;

  return <CreateEditInvoiceForm invoice={invoice} mode="edit" />;
};
